import { round2 } from '../../../lib/sponsorPledgeFlowMath'
// TODOOOO: need to expand this to deal with the business logo and cover banner, talk to Debby about if we want this to pull from business profile or what
// message visible to the event organizer (not the public event tagline)
export function normalizeMessageToEventOwner(message) {
  return String(message ?? '').trim()
}

// keep VPF+MPF summing to amount after rounding
export function integerPledgeAllocation(commitmentNum, vpfAmount, mpfAmount) {
  const amount = Math.round(Number(commitmentNum) || 0)
  const vpfRounded = Math.round(Number(vpfAmount) || 0)
  let mpf_amount = amount - vpfRounded
  let vpf_amount = vpfRounded
  if (mpf_amount < 0) {
    vpf_amount = amount
    mpf_amount = 0
  }
  return { amount, vpf_amount, mpf_amount }
}

//  for POST civ_pledges.json (nested civ_pledge)
export function buildCreateCivPledgeRequestBody({
  eventId,
  stripePaymentMethodId,
  commitmentNum,
  vpfAmount,
  mpfAmount,
  opsNum,
  civillosAdminFeeId,
  metaAdminFeeId,
  messageToEventOwner,
  termsAcceptedAtIso,
}) {
  const { amount, vpf_amount, mpf_amount } = integerPledgeAllocation(
    commitmentNum,
    vpfAmount,
    mpfAmount,
  )
  const opsRounded = Math.max(0, Math.round(Number(round2(opsNum)) || 0))
  const organizerNote = normalizeMessageToEventOwner(messageToEventOwner)

  return {
    event_id: eventId,
    stripe_payment_method_id: stripePaymentMethodId,
    civ_pledge: {
      amount,
      vpf_amount,
      mpf_amount,
      ...(opsRounded > 0 ? { ops_donation_amount: opsRounded } : {}),
      message_to_event_owner: organizerNote,
      civillos_admin_fee_id: civillosAdminFeeId,
      meta_admin_fee_id: metaAdminFeeId,
      terms_accepted_at: termsAcceptedAtIso,
    },
  }
}
